<template>
  <div class="m-4">
    <h1 class="text-center" @click="decode('https://hotel.tabarok.ir?room_number=101')">کد QR اتاق خود را اسکن کنید.</h1>
    <VAlert v-if="error">{{ error }}</VAlert>
  </div>
  <QrcodeStream @decode="decode" @init="onInit">
    <LoadingSpinner class="mx-auto mt-[50%] w-16 h-16"  v-if="loading"/>
  </QrcodeStream>
</template>

<script>
import {QrcodeStream} from "vue3-qrcode-reader";
import LoadingSpinner from "@/components/General/LoadingSpinner";
import VAlert from "@/components/General/VAlert";

export default {
  name: "QRScannerPage",
  components: {VAlert, LoadingSpinner, QrcodeStream},
  data() {
    return {
      room: {},
      loading: false,
      error: ''
    }
  },
  methods: {
    decode(result) {
      if (!result.startsWith('https://hotel.tabarok.ir?room_number=')) {
        this.error = 'کد اسکن شده معتبر نیست !'
        return
      }

      let url = new URL(result)
      this.$store.dispatch('setRoomNumber', url.searchParams.get("room_number"))
      if (this.$route.query.callback === 'cart') {
        // Open CartBottomSheet On Return
        this.$router.push({
          path: '/',
          query: {
            callback: 'cart'
          }
        })
      } else {
        // Go to Service Category Page
        this.$router.replace({
          path: '/category/service',
        })
      }

    },
    async onInit (promise) {
      this.loading = true

      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        } else if (error.name === 'InsecureContextError') {
          this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
        } else {
          this.error = `ERROR: Camera error (${error.name})`;
        }
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>

</style>